import type AccessibleFeature from './models/AccessibleFeature';

import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed, watch } from 'vue';

import { uniq } from 'lodash-es';

import ApiResultStatus from '../../../shared/api/api-result/ApiResultStatus';
import useCurrentUserId from '../../authentication/current-user/useCurrentUserId';
import getAccessibleFeatures from './api/getAccessibleFeatures';

export default defineStore('currentUserAccessibleFeatures', () => {
  const accessibleFeatures = useLocalStorage<AccessibleFeature[]>('currentUserAccessibleFeatures', []);

  const currentUserId = useCurrentUserId();

  const loadAccessibleFeatures = async () => {
    if (currentUserId.value === null) {
      return;
    }

    const result = await getAccessibleFeatures(currentUserId.value);

    if (result.status !== ApiResultStatus.OK) {
      accessibleFeatures.value = [];

      return;
    }

    accessibleFeatures.value = uniq(result.accessibleFeatures);
  };

  watch(
    currentUserId,
    () => {
      void loadAccessibleFeatures();
    },
    {
      immediate: true,
    },
  );

  const checkIfHasAccessToFeature = computed(() => {
    const accessibleFeaturesValue = accessibleFeatures.value;

    return (feature: AccessibleFeature) => accessibleFeaturesValue.includes(feature);
  });

  return {
    checkIfHasAccessToFeature,
  };
});
